import Card from "./Card";

function SettingCard({

    title,

    children

}){

    return(

        <Card>

            <h3
                style={{
                    marginTop:0,
                    marginBottom:"18px"
                }}
            >

                {title}

            </h3>

            {children}

        </Card>

    );

}

export default SettingCard;